import axios from 'axios'
import { apiBaseUrl } from '@/variables/localVariables'


export class APIPrivatePerson {

  createPrivatePerson(data) {
    let url = `${apiBaseUrl}/private-persons/create/`
    var headers = {
      'Content-Type': 'application/json',
    }
    return axios.post(url, data, {'headers': headers,})
  }
  findPrivatePersonDuplicates ({field, value, userId}) {
    const url = `${apiBaseUrl}/private-persons/duplicates/`
    const params = {
      field: field,
      value: value,
    }
    if (userId) {
      params.userId = userId
    }
    const headers = {
      'Content-Type': 'application/json',
    }
    return axios.post(url, params, {'headers': headers})
  }

  getPrivatePersons( {page, search, ageRange, gender, professions}) {
    let url = `${apiBaseUrl}/private-persons/?page=${page}`

    if (search) {
      url += `&search=${search}`
    }

    if (ageRange) {
      url += `&ageRange=${ageRange}`
    }

    if (gender) {
      url += `&gender=${gender}`
    }

    if (professions) {
      url += `&professions=${professions}`
    }

    const headers = {
      'Content-Type': 'application/json',
    }

    return axios.get(url, {'headers': headers})
  }

}
